const translations = {
	en: {
		slider: {
			previous: "Previous",
			next: "Next",
		},
	},
	de: {
		slider: {
			previous: "Zurück",
			next: "Weiter",
		},
	},
};

// todo: woher sollte man die Sprache nehmen? Vergleiche andere Stellen
const language = window.ocm?.config?.language || "de";

export const translate = ((language) => translations[language] || translations["en"])(language);
